import * as Yup from "yup";
const generalErrorMessge = "Field is required";
export const validationSchema = Yup.object({
  geographical_regions_selection: Yup.string()
    .required("Geographical_Regions_Selection is required")
    .min(1, "Geographical_Regions_Selection is required"),
    geographical_regions_details_others: Yup.string().when(["geographical_regions_selection"], {
      is: (geographical_regions_selection) =>
        geographical_regions_selection && geographical_regions_selection === "Other",
      then: () =>
        Yup.string()
          .required("Field is required"),
      otherwise: () => Yup.string().optional(),
    }),
});
